import { useCurrentUser } from 'api/hooks/useCurrentUser';
import { TenantType } from 'api/models/Users';
import { useLanguage } from 'context/AppContext';
import { useMemo } from 'react';

const useStatusTranslations = () => {
  const lang = useLanguage()[0];

  const { data: user } = useCurrentUser();

  return useMemo(() => {
    const statusLang = { ...lang.OrderStatusText, ...lang.DeliveryStatusText };

    // special case: RECEIVE and DELIVERED have a per user type translation
    if (user?.tenant.type == TenantType.HOSPITAL) {
      statusLang.RECEIVE = statusLang.RECEIVE_HOSPITAL;
      statusLang.DELIVERED = statusLang.DELIVERED_HOSPITAL;
    }

    return statusLang;
  }, [lang.DeliveryStatusText, lang.OrderStatusText, user?.tenant.type]);
};

export default useStatusTranslations;
